import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=6c892dec&scoped=true&"
import script from "./DownloadApp.vue?vue&type=script&lang=ts&"
export * from "./DownloadApp.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=6c892dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c892dec",
  null
  
)

export default component.exports